import React from 'react';
// import PropTypes from 'prop-types';
import SidebarFooter from '../SidebarFooter';
// import Button from '../../Button';
// import dayjs from 'dayjs';
// import uuidv4 from 'uuid/v4';
// import { Upload, Download } from 'react-feather';
import { connect } from 'dva';
// import { SIDEBAR_VIEWS } from '../../../lib/constants';
import styles from './Help.module.scss';

function HelpFooter(props) {
  props;
  /*const goToImportSidebar = (e) => {
    e.preventDefault();

    props.dispatch({
      type: 'app/gotoSidebar',
      payload: SIDEBAR_VIEWS.Import
    });
  };

  const goToExportSidebar = (e) => {
    e.preventDefault();

    props.dispatch({
      type: 'app/gotoSidebar',
      payload: SIDEBAR_VIEWS.Export
    });
  };*/

  return (
    <SidebarFooter className={styles.footer}>
      <div>help footer placeholder</div>
      {/* <Button onClick={goToImportSidebar}>
        <Upload style={{marginRight: 7}}/>
        Import
      </Button>
      <Button onClick={goToExportSidebar}>
        <Download style={{marginRight: 7}}/>
        Export
      </Button> */}
    </SidebarFooter>
  );
}

HelpFooter.propTypes = {

};

export default connect(()=>{return {};})(HelpFooter);
